import type { GetOrgObjectWithFilteringBody } from "~/lib/database/types";

export const defaultPeopleQuery: GetOrgObjectWithFilteringBody = {
  q: "",
  page: 1,
  limit: 50,
  filters: [],
  sortings: [],
};
export const CONTACTS_ID_COLUMN_ID = "contacts_id_serial";
export const CONTACTS_RIGHT_SIDEBAR_WIDTH_KEY = "contactsRightSidebarWidth";

export enum ContactsRightSidebarTabKeys {
  EMAILS = "contacts-right-sidebar-emails",
  NOTES = "contacts-right-sidebar-notes",
  ACTIVITY = "contacts-right-sidebar-activity",
  FILES = "contacts-right-sidebar-files",
  DOCUSIGN = "contacts-right-sidebar-docusign",
}

export const ActivityTypeEnum = {
  EMAIL: "EMAIL",
  MEETING: "MEETING",
};
